import Nav from './Nav'


function Pillar5() {
    let selectedPil="pillar ";
    let pillarHeading="";
    let pillar1Text="";
  
      selectedPil += " social-cohesion";
      pillarHeading = "Social Cohesion and Community Resilience";
      pillar1Text="Communities have borne the brunt of the socio-economic impact of COVID19. As predicted, the pandemic has placed considerable strains on social cohesion, magnifying existing fault lines and creating new ones. UN country teams used their expertise and convening power to foster social dialogue and consensus about key measures related to the socio-economic response to COVID-19. UN Country Teams deployed their networks and partnerships to bring together representatives of national Government with a wide range national stakeholders, institutions and civil society leaders. ";
      return(
        <>
        <Nav active="p5" />
        <div className={selectedPil}>
                  <PillarStart text={pillar1Text} pilHeading={pillarHeading} />
                  <div className="customcontainer">
                    <TopKeyFigureSection active="p5" />
                    <Pillar5IndicatorSection heading="Employer Organization Supported With Institutional Capacity Building" indiNum="1" lineChart1Heading="PeopleQuarterly Progress"  lineChart2Heading="" />
                    <Pillar5IndicatorSection heading="Community Organization Capacitated For Resilience" indiNum="2" kfHeading="" lineChart1Heading="Quarterly Progress (Organizations)"  lineChart2Heading="Quarterly Progress (Organizations)" />
                    <Pillar5IndicatorSection heading="Social Dialogues Spaces Facilitated for At Risk Population. " indiNum="3" kfHeading="Spaces facilitated" lineChart1Heading="Quarterly Progress (Advocacy and political eng.)"  lineChart2Heading="Quarterly Progress (Social dialogue spaces)" />
                  </div>
                  <TableSection />
        </div>
        </>
      );

}

function TableSection()
{
  return(
    <div className="white-background">
      <div className="customcontainer">
          <div className="customrow">
              <div className="col-md-12">
                  <div className="title">
                      <div className="funded"></div>
                      <div className="text pillar">&nbsp;</div>
                  </div>
              </div>
              <table id="table" className="table table-hover"></table>
          </div>
      </div>
  </div>
  )
}

function PillarStart({text,pilHeading}){
    return (
      <div className="customcontainer">
                    <div className="topContent"><p>{text}</p></div>
                    <div className="customrow">
                        <div className="col-md-12">
                            <h1 className="pillar-title">
                                {pilHeading}
                            </h1>
                        </div>
                    </div>
                </div>
    )
  }

function TopKeyFigureSection({active})
{
      return(
        <div className="customrow">
          <div className="col-md-12">
            <div className="pillar5-blocks">
              <TopKeyFigure heading="EMPLOYER ORGANIZATIONS" div_id="1" keyFigure = "2,816"/>
              <TopKeyFigure heading="TRADE UNIONS " div_id="2" keyFigure = "339"/>
            </div>
          </div>
        </div>
      )
}

function TopKeyFigure({heading, div_id, keyFigure})
{
  let divNAid="top-number"+div_id+"NA";
  let divID="top-number"+div_id;
  return(
    <div className="pillar-block">
      <div className="header">
          <div className="text text-center">
              {heading}
          </div>
      </div>
      <div className="body">
          <div className="counter text-center">
              <span id={divNAid}></span>
              <span id={divID}>{keyFigure}</span>
          </div>
      </div>
  </div>
  )
}


function IndKeyFigure({heading,div_id,indValue})
{
  console.log(div_id);
  return(
    <>
      <div className="counter text-center">
        <span id={div_id} className="kf-number">{indValue}</span>
      </div>
      <div className="title" style={{textAlign: 'center'}}>
          <div className="text">{heading}</div>
      </div>
    </>
  )
}


function Pillar5IndicatorSection({heading,indiNum,kfHeading,lineChart1Heading,lineChart2Heading}){
    let indDivID="Ind1."+indiNum;
    let kfDivID="number"+indiNum;
    let qrtChartID="";
    let rowChartID="";
    let qrtChartContainerID="";
    let qrtNAContainerID="";
    let rowChartContainerID="";
    let rowNAContainerID="";
    if(indiNum==="1")
    {
      qrtChartID="chart1-5."+indiNum;
      rowChartID="chart2-5."+indiNum;
      qrtChartContainerID="quater"+indiNum;
      rowChartContainerID="indicator"+indiNum;
      qrtNAContainerID="5."+indiNum+"chart1NA";
      rowNAContainerID="5."+indiNum+"chart2NA";
      return(
        <div id={indDivID} className="customrow">
          <div className="pillar social-cohesion">
              <div className="customcontainer">
                  <div className="customrow">
                      <div className="col-md-12">
                          <h1 className="indicator-title">
                              {heading}
                          </h1>
                      </div>
                  </div>
              </div>
          </div>
          <div id={qrtChartID} className="col-md-6">
            <div className="funded">
                <div className="title">
                    <div className="text">{lineChart1Heading}</div>
                </div>
                <div className="content">
                    <div id={qrtChartContainerID}>
                    </div>
                    <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                    <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG5.1a" width="50" height="50" />
                        <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      );
    }
    else{
    if(indiNum==="2")
    {
      qrtChartID="chart1-5."+indiNum;
      rowChartID="chart2-5."+indiNum;
      qrtChartContainerID="quater"+indiNum;
      rowChartContainerID="indicator"+indiNum;
      qrtNAContainerID="5."+indiNum+"chart1NA";
      rowNAContainerID="5."+indiNum+"chart2NA";
      return(
        <div id={indDivID} className="customrow">
          <div className="pillar social-cohesion">
              <div className="customcontainer">
                  <div className="customrow">
                      <div className="col-md-12">
                          <h1 className="indicator-title">
                              {heading}
                          </h1>
                      </div>
                  </div>
              </div>
          </div>
          <div id={qrtChartID} className="col-md-6">
            <div className="funded">
                <div className="title">
                    <div className="text">{lineChart1Heading}</div>
                </div>
                <div className="content">
                    <div id={qrtChartContainerID}>
                    </div>
                    <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                    <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG5.2a" width="50" height="50" />
                        <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                    </div>
                </div>
            </div>
          </div>
          <div id={rowChartID} className="col-md-6">
              <div className="funded">
                  <div className="title">
                      <div className="text">{lineChart2Heading}</div>
                  </div>
                  <div className="content">
                      <div id={rowChartContainerID}>
                      </div>
                      <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                      <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG5.2b" width="50" height="50" />
                          <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      );
    }
      else
      {
          qrtChartID="chart1-1."+indiNum;
          rowChartID="chart2-1."+indiNum;
          qrtChartContainerID="quater"+indiNum;
          rowChartContainerID="indicator"+indiNum;
          qrtNAContainerID="1."+indiNum+"chart1NA";
          rowNAContainerID="1."+indiNum+"chart2NA";
      
          return(
            <div id={indDivID} className="customrow">
              <div className="pillar social-cohesion">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  {heading}
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-md-2">
                <div className="funded">
                  <div className="body">
                    <div className="burger">
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </div>
                    <IndKeyFigure heading={kfHeading} div_id={kfDivID} unit="" value = "1000" indValue ="1,067"/>
                  </div>
                </div>
              </div>
              <div id={qrtChartID} className="col-md-5">
                <div className="funded">
                    <div className="title">
                        <div className="text">{lineChart1Heading}</div>
                    </div>
                    <div className="content">
                        <div id={qrtChartContainerID}>
                        </div>
                        <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                        <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG5.3a" width="50" height="50" />
                            <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                        </div>
                    </div>
                </div>
              </div>
              <div id={rowChartID} className="col-md-5">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{lineChart2Heading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG5.3b" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          );
      }
  
  }
}


export default Pillar5;